export enum typeCandidatureEnum {
	premiereLocation = '1',
	ajoutAppartement = '2',
	changementAppartement = '4',
	ajoutParking = '3',
	changementParking = '5'
}

export enum statutCommercialisationDossierEnum {
	creation = 221310000,
	complete = 1,
	toUpdate = 221310012,
	abandoned = 221310011,
	toSendToComity = 221310014,
	refused = 221310010,
	accepted = 221310005,
	signed = 221310006,
	payed = 221310007,
	definitive = 2,
	recycling = 221310013
}
